import React from 'react'
import { Input as InputInno } from '../../../../../../../components/Form/Input'

export const Input = React.forwardRef(({ error, label, id, ...props }, ref) => {
  return (
    <InputInno
      ref={ref}
      border="1px solid #CFCFCF"
      size="sm"
      bgColor="transparent"
      py={'6px'}
      alignItems="center"
      justifyContent="center"
      fontWeight="bold"
      {...props}
    />
  )
})
